import { useNavigate, useLocation, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useCollection } from '../contexts/CollectionContext';
import WebApp from "@twa-dev/sdk";
import config from '../config';
import sellSound from '../assets/music/sell.mp3';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { apiService } from '../services/api';
import useUserStore from '../stores/userStore';
import CurrencyIcon from './CurrencyIcon';
import { useAdsgram } from '../hooks/useAdsgram';
import fragsIcon from '../assets/frags.png';
import { useTranslation } from 'react-i18next';
import { IoShareSocial } from 'react-icons/io5';
import { IoCopyOutline } from 'react-icons/io5';

const CaseResult = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { assetId } = useParams();
  const { weapon, caseId, caseCost } = location.state;
  const { removeFromCollection } = useCollection();
  const user = useUserStore(state => state.user);
  const setUser = useUserStore.setState;
  const fetchBalance = useUserStore(state => state.fetchBalance);
  const balance = user?.balance ? parseFloat(user.balance) : 0;
  const [shareLoading, setShareLoading] = useState(false);
  const [respinLoading, setRespinLoading] = useState(false);
  const [respinAvailable, setRespinAvailable] = useState(false);
  const [respinLeft, setRespinLeft] = useState(null);
  const [newDrop, setNewDrop] = useState(null);
  const isRespin = location.state?.isRespin;
  const { t } = useTranslation();
  const [respinLimit, setRespinLimit] = useState(null);
  const [showRespinModal, setShowRespinModal] = useState(false);
  const botName = '@skinforge_bot';

  // Проверка условий для отображения кнопки респина
  useEffect(() => {
    async function checkRespinLimit() {
      // Проверяем, что это кейс Eco Rush (ID: 790b6444-2439-4240-85c4-0f28ad59289b)
      if (caseId !== '790b6444-2439-4240-85c4-0f28ad59289b') {
        setRespinAvailable(false);
        setRespinLeft(null);
        setRespinLimit(null);
        return;
      }

      try {
        const stats = await apiService.getRespinStats();
        if (stats && 'left' in stats && 'limit' in stats) {
          setRespinLeft(stats.left);
          setRespinAvailable(stats.left > 0);
          setRespinLimit(stats.limit);
        } else {
          setRespinAvailable(false);
          setRespinLeft(null);
          setRespinLimit(null);
        }
      } catch {
        setRespinAvailable(false);
        setRespinLeft(null);
        setRespinLimit(null);
      }
    }
    checkRespinLimit();
  }, [user, weapon, caseId]);

  // Вынесенная функция для респина
  const handleRespinReward = async () => {
    setRespinLoading(true);
    try {
      const respinResult = await apiService.respinCase(assetId);
      console.log('respinResult', respinResult);
      if (respinResult && respinResult.item) {
        navigate(`/case/${caseId}`, {
          state: {
            autoSpin: true,
            respinDrop: respinResult.item
          },
          replace: true
        });
      } else {
        toast.error(t('case.respinError'));
      }
    } catch (e) {
      toast.error(t('case.respinRequestError'));
    } finally {
      setRespinLoading(false);
    }
  };

  const showRespinAd = useAdsgram({
    blockId: '12551',
    onReward: handleRespinReward,
    onError: () => {
      toast.error(t('case.adError'));
    },
    fetchBalance,
    showToast: false
  });

  useEffect(() => {
    WebApp.BackButton.show();

    const handleBackButton = () => {
      navigate(`/case-contents/${caseId}`, { replace: true });
    };

    WebApp.onEvent('backButtonClicked', handleBackButton);

    return () => {
      WebApp.BackButton.hide();
      WebApp.offEvent('backButtonClicked', handleBackButton);
    };
  }, [navigate, caseId]);

  const handleSell = async () => {
    try {
      await apiService.createSale(weapon.id);

      const audio = new Audio(sellSound);
      audio.play();

      await fetchBalance();

      removeFromCollection(parseInt(assetId));

      navigate(`/case/${caseId}`, { replace: true });
    } catch (error) {
      console.error('Error selling weapon:', error);
      toast.error(t('case.sellError'), {
        position: "top-center",
        theme: "dark"
      });
    }
  };

  const handleShare = async () => {
    setShareLoading(true);
    try {
      const response = await apiService.savePreparedInlineMessage({ item_id: weapon.id });
      const inlineMessageId = response.id;
      if (window.Telegram?.WebApp?.openTelegramLink && inlineMessageId) {
        window.Telegram.WebApp.shareMessage(inlineMessageId);
      } else {
        await navigator.clipboard.writeText(inlineMessageId);
        toast.success(t('case.idCopied') + ': ' + inlineMessageId);
      }
    } catch (e) {
      toast.error(t('case.shareError'));
    } finally {
      setShareLoading(false);
    }
  };

  console.log(respinAvailable);
  return (
    <Container>
      <WeaponCard>
        <WeaponImage
          src={config.getImageUrl(weapon.iconUrl)}
          alt={weapon.name}
        />
        <WeaponInfo>
          <WeaponName>
            {(() => {
              const parts = weapon.name.split(' | ');
              return (
                <>
                  <span style={{ fontWeight: 800, color: '#fff', display: 'block', fontSize: '32px', lineHeight: '1.1', marginBottom: '10px' }}>{parts[0]}</span>
                  {parts.slice(1).map((part, idx) => (
                    <span key={idx} style={{ color: '#bdbdbd', display: 'block', fontWeight: 400, fontSize: '16px', lineHeight: '1.2', marginBottom: idx !== parts.length - 2 ? '4px' : 0 }}>{part}</span>
                  ))}
                </>
              );
            })()}
          </WeaponName>
          {/* <WeaponVariant>{weapon.variant || 'Field-Tested'}</WeaponVariant> */}
        </WeaponInfo>
        <ActionButtons>
          <SellButton onClick={handleSell}>
            <SellButtonContent>
              {t('skin.sellFor')}
              <PriceInline>
                <CurrencyIcon size={18} />
                {weapon.tokenPrice}
              </PriceInline>
            </SellButtonContent>
          </SellButton>
          <ShareIconButton onClick={handleShare} disabled={shareLoading}>
            <IoShareSocial />
          </ShareIconButton>
        </ActionButtons>
        {newDrop && (
          <div style={{ marginTop: 16, color: '#fff', textAlign: 'center' }}>
            {t('case.newDrop')}: <b>{newDrop.name || newDrop.marketHashName}</b>
          </div>
        )}
      </WeaponCard>

      <ButtonsContainer>
        <BackButton onClick={() => navigate(`/case-contents/${caseId}`, { replace: true })}>
          {t('common.back', 'Назад')}
        </BackButton>
        {caseId === '790b6444-2439-4240-85c4-0f28ad59289b' && (
          <>
            <RespinButton onClick={showRespinAd} disabled={respinLoading || !respinAvailable || Number(respinLeft) <= 0}>
              {respinLoading ? t('case.respinLoading') : (
                <>
                  {t('case.respin')}
                  <img src={fragsIcon} alt="frags" style={{ width: 20, height: 20, verticalAlign: 'middle' }} />
                  <span>{t('case.fragsZero')}</span>
                </>
              )}
            </RespinButton>
            <RespinInfo>
              {t('case.respinsLeftToday', { left: respinLeft ?? 0, limit: respinLimit ?? '—' })}
              <button
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#2563eb',
                  fontWeight: 600,
                  fontSize: 16,
                  cursor: 'pointer',
                  marginLeft: 12,
                  display: 'inline',
                  padding: 0,
                  textDecoration: 'none',
                }}
                onClick={() => setShowRespinModal(true)}
              >
                {t('case.wantMore')}
              </button>
            </RespinInfo>
            {showRespinModal && (
              <div style={{
                position: 'fixed', left: 0, top: 0, right: 0, bottom: 0, zIndex: 2000,
                background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center'
              }}>
                <div style={{
                  background: 'rgb(35, 35, 58)',
                  borderRadius: 20,
                  padding: 32,
                  margin: 32,
                  maxWidth: 450,
                  color: 'rgb(255,255,255)',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  overflow: 'hidden'
                }}>
                  <h2 style={{ textAlign: 'center', marginBottom: 12, fontWeight: 800, fontSize: 22 }}>
                    {t('moreRespinsModal.title')}<span role="img" aria-label="fire" style={{ verticalAlign: 'middle', marginLeft: 2 }}>🔥</span>
                  </h2>
                  <div style={{ textAlign: 'center', color: '#bbb', marginBottom: 18, fontSize: 16, lineHeight: 1.5 }}>
                    {t('moreRespinsModal.desc')}<br /><br />
                    <p style={{ textAlign: 'center', fontWeight: 600, margin: 0 }}>
                      {t('moreRespinsModal.bonus', { bot: '' }).replace(/\.?\s*{{bot}}\s*\.?/, '')}
                      <span style={{ color: '#4b69ff' }}>{botName}</span>.
                    </p>
                  </div>
                  <div
                    style={{
                      background: 'rgba(30,30,30,0.98)',
                      borderRadius: 16,
                      padding: '12px 18px',
                      fontSize: 20,
                      color: '#fff',
                      textAlign: 'center',
                      margin: '0 auto 18px auto',
                      cursor: 'pointer',
                      userSelect: 'all',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                      minWidth: 260,
                      justifyContent: 'center' // выравнивание по центру
                    }}
                    onClick={() => {
                      navigator.clipboard.writeText('@skinforge_bot');
                      toast.success(t('common.copied'));
                    }}
                    title={t('moreRespinsModal.copy')}
                  >
                    @skinforge_bot
                    <IoCopyOutline size={22} style={{ opacity: 0.8 }} />
                  </div>
                  <div style={{ color: '#bbb', fontSize: 15, textAlign: 'center', marginBottom: 18 }}>
                    {t('moreRespinsModal.important')}
                  </div>
                  <button
                    style={{
                      background: '#2563eb',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 12,
                      padding: '12px 0',
                      fontSize: 18,
                      fontWeight: 700,
                      width: '100%',
                      cursor: 'pointer'
                    }}
                    onClick={() => setShowRespinModal(false)}
                  >
                    {t('moreRespinsModal.ok')}
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </ButtonsContainer>
    </Container>
  );
};

const Container = styled.div`
  ${'' /* padding-top: 50px; */}
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background: ${props => props.theme.background};
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 120px;

  /* Скрываем скроллбар, но оставляем функциональность */
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const WeaponCard = styled.div`
  width: calc(100% - 40px);
  max-width: 520px;
  background: ${props => props.theme.card.background};
  border-radius: 16px;
  padding: 40px 24px 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
  margin: 32px auto;
`;

const WeaponImage = styled.img`
  width: 280px;
  height: 210px;
  object-fit: contain;
  animation: levitate 2.6s ease-in-out infinite;
  margin-bottom: 32px;

  @keyframes levitate {
    0% { transform: translateY(0); }
    50% { transform: translateY(-14px); }
    100% { transform: translateY(0); }
  }
`;

const WeaponInfo = styled.div`
  text-align: center;
`;

const WeaponName = styled.h2`
  color: ${props => props.theme.text.primary};
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 16px 0;
  text-align: center;
`;

const WeaponVariant = styled.div`
  color: #8E8E93;
  font-size: 16px;
  margin-top: 4px;
`;

const ActionButtons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 32px;
  margin-bottom: 0;
  gap: 16px;
`;

const SellButton = styled.button`
  flex: 1 1 0;
  background: #2196f3;
  color: #fff;
  border: none;
  border-radius: 14px;
  padding: 14px 0;
  font-size: 17px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  min-width: 0;
  max-width: 100%;
  transition: background 0.2s;
  box-shadow: 0 2px 8px rgba(33,150,243,0.10);
  &:hover { background: #1976d2; }
`;

const SellButtonContent = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 8px;
`;

const PriceInline = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

const ShareIconButton = styled.button`
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #3a2e1a;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 22px;
  margin-left: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.10);
  cursor: pointer;
  transition: background 0.2s;
  &:hover { background: #5a4222; }
`;

const ButtonsContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  padding: 20px;
  padding-bottom: max(20px, env(safe-area-inset-bottom));
  background: ${props => props.theme.background};
  z-index: 10;
`;

const BackButton = styled.button`
  background: #232323;
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 16px;
  font-size: 17px;
  font-weight: 500;
  cursor: pointer;
  width: 100%;
  transition: background 0.2s;
  &:hover { background: #181818; }
`;

const RespinButton = styled.button`
  background: #2196f3;
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 16px;
  font-size: 18px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  width: 100%;
  box-shadow: 0 2px 8px rgba(33,150,243,0.10);
  transition: background 0.2s, color 0.2s;
  &:hover { background: #1976d2; }
  &:disabled {
    background: #3a3a3a;
    color: #888;
    cursor: not-allowed;
  }
`;

const RespinInfo = styled.div`
  text-align: center;
  color: #aaa;
  font-size: 14px;
  margin-top: 4px;
`;

export default CaseResult;